import { render, staticRenderFns } from "./TodayJobPieChart.vue?vue&type=template&id=332bd42c&"
import script from "./TodayJobPieChart.vue?vue&type=script&lang=js&"
export * from "./TodayJobPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports